export const adminMembershipsApi = {

    getAll() {
        return axios.get(`/api/admin/membership`)
    },

}
